/**
 * Scroll-based animations using Intersection Observer
 * Animates elements with .scroll-animate class when they enter the viewport
 */
(function () {
  // Configuration - trigger when element is more visible in viewport
  const defaultOptions = {
    threshold: 0.25,  // Trigger when 25% of element is visible (was 15%)
    rootMargin: '0px 0px -200px 0px'  // Require element to be 200px into viewport (was 100px)
  };

  /**
   * Handles intersection events for animated elements
   */
  function handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Apply delay if specified via data attribute
        const delay = entry.target.dataset.animateDelay || 0;

        if (delay > 0) {
          entry.target.style.setProperty('--animate-delay', `${delay}ms`);
        }

        // Add visible class to trigger animation
        entry.target.classList.add('is-visible');

        // Unobserve after animation (single trigger)
        observer.unobserve(entry.target);
      }
    });
  }

  // Initialize observer
  const observer = new IntersectionObserver(handleIntersection, defaultOptions);

  // Observe all elements with scroll-animate class when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.scroll-animate, .scroll-animate-right, .scroll-animate-slow, .scroll-animate-fade');
    elements.forEach(el => {
      observer.observe(el);
    });
  });
})();
